// import React from "react";
// import images from "../../../images.config";
// import GlobalButton from "../../GlobalButton";
// import routes from "../../routes";

// const HeroSection = () => {
//   return (
//     <section className="relative w-full h-screen py-2 top-16  flex items-center justify-center overflow-hidden bg-tertiary z-30 ">
//       {/* Video Background */}
//       {/* <video
//         className="absolute top-0 left-0 w-full h-full object-cover"
//         src="your-video-url.mp4"
//         autoPlay
//         muted
//         loop
//       /> */}
//       <img
//         src={images.heroVideo}
//         alt="hero section video"
//         className="absolute top-0 left-0 w-full h-full object-cover"
//       />

//       {/* Overlay */}
//       <div className="absolute inset-0 bg-black bg-opacity-50"></div>

//       {/* Text Content */}
//       <div className="relative z-10 w-full h-full flex items-end px-11 md:px-12">
//         <div className="text-white mb-12 w-full lg:text-left lg:pl-20 relative lg:bottom-5">
//           <h1 className="text-3xl md:text-4xl font-outfit font-light mb-6">
//             <span className="whitespace-normal md:whitespace-nowrap">
//               EXQUISITE FIT,
//             </span>
//             <span className="block md:inline md:whitespace-nowrap">
//               {" "}
//               PREMIUM STYLE.
//             </span>
//           </h1>

//           {/* <p className="text-lg md:text-xl mb-8">
//             Some description or tagline for your hero section goes here.
//           </p> */}

//           <button className="border-2 py-2 px-5 flex hover:text-hcolor font-outfit font-medium bg-hcolor text-primary2 hover:bg-tertiary transition-all duration-500 ease-in-out">
//             <GlobalButton label="EXPLORE" routeName="shop" />
//           </button>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default HeroSection;


// import React from "react";
// import GlobalButton from "../../GlobalButton";
// import { IMAGE_BASE_URL } from "../../../api-urls";

// const HeroSection = ({ bannerData}) => {
//   if (!bannerData || !Array.isArray(bannerData) || bannerData.length === 0) {
//     console.warn("Banner data is empty or invalid:", bannerData);
//     return null; // Prevents rendering if no banner data is available
//   }
//   return (

//     <section className="relative w-full h-screen py-2 top-16 flex items-center justify-center overflow-hidden bg-tertiary z-30">
//       {Object.values(bannerData).map((banner, index) => (
//         <div key={index} className="absolute w-full h-full">
//           {/* Background Image or Video */}
//           {banner?.video ? (
//             <video className="absolute top-0 left-0 w-full h-full object-cover" src={banner.file} autoPlay muted loop />
//           ) : (
//             <img
//               src={banner?.file || "/fallback-image.jpg"}
//               alt="Hero banner"
//               className="absolute top-0 left-0 w-full h-full object-cover"
//             />
//           )}

//           {/* Overlay */}
//           <div className="absolute inset-0 bg-black bg-opacity-50"></div>

//           {/* Text Content */}
//           <div className="relative z-10 w-full h-full flex items-end px-11 md:px-12">
//             <div className="text-white mb-12 w-full lg:text-left lg:pl-20 relative lg:bottom-5">
//               <h1 className="text-3xl md:text-4xl font-outfit font-light mb-6">
//                 {banner?.title || "EXQUISITE FIT, PREMIUM STYLE."}
//               </h1>

//               <button className="border-2 py-2 px-5 flex hover:text-hcolor font-outfit font-medium bg-hcolor text-primary2 hover:bg-tertiary transition-all duration-500 ease-in-out">
//                 <GlobalButton label={banner?.buttonText || "EXPLORE"} routeName="shop" />
//               </button>
//             </div>
//           </div>
//         </div>
//       ))}
//     </section>
   
//   );
// };

// export default HeroSection;

import React from "react";
import GlobalButton from "../../GlobalButton";
import { IMAGE_BASE_URL } from "../../../api-urls";



const HeroSection = ({ bannerData }) => {
  if (!bannerData) {
    console.warn("HeroSection received empty or invalid bannerData");
    return null; // Don't render if no data
  }

  // Ensure `bannerData` is always an array
  const banners = Array.isArray(bannerData) ? bannerData : [bannerData];

  return (
    <section className="relative w-full h-screen py-2 top-16 flex items-center justify-center overflow-hidden bg-tertiary z-30">
      {banners.map((banner, index) => (
        <div key={banner._id || index} className="absolute w-full h-full">
          {/* Background Image or Video */}
          {banner?.type === "video" ? (
            <video className="absolute top-0 left-0 w-full h-full object-cover" src={IMAGE_BASE_URL+banner.file} autoPlay muted loop />
          ) : (
            <img
              src={IMAGE_BASE_URL+banner?.file || "/fallback-image.jpg"}
              alt="Hero banner"
              className="absolute top-0 left-0 w-full h-full object-cover"
            />
          )}

          {/* Overlay */}
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>

          {/* Text Content */}
          <div className="relative z-10 w-full h-full flex items-end px-11 md:px-12">
            <div className="text-white mb-12 w-full lg:text-left lg:pl-20 relative lg:bottom-5">
              <h1 className="text-3xl md:text-4xl font-outfit font-light mb-6">
                {banner?.title || "EXQUISITE FIT, PREMIUM STYLE."}
              </h1>

              <button className="border-2 py-2 px-5 flex hover:text-hcolor font-outfit font-medium bg-hcolor text-primary2 hover:bg-tertiary transition-all duration-500 ease-in-out">
                <GlobalButton label={banner?.buttonText || "EXPLORE"} routeName="shop" />
              </button>
            </div>
          </div>
        </div>
      ))}
    </section>
  );
};

export default HeroSection;
